<template>
  <el-tabs v-model="activeName" type="card">
    <!-- <el-tab-pane label="上传日志" name="first"> -->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters" label-width="100px">
          <!-- <el-form-item label="Status"> -->
            <!--<el-select v-model="filters.nType" placeholder="">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>-->
          <!-- </el-form-item> -->
          <el-form-item>
            <!--<el-button type="primary" v-on:click="reGetList()">
								Search
							</el-button>-->
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; border-radius: 20px 20px 0 0; overflow: hidden"
          :header-cell-style="headerStyle"
          :cell-style="cellStyle"
        >
          <el-table-column
            prop="sOperationName"
            label="Operation  Name"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="dTime"
            align="center"
            label="Upload Time"
          ></el-table-column>
          <el-table-column
            prop="sTemplateName"
            label="Template Name"
          ></el-table-column>
          <el-table-column prop="sTableName" align="center" label="Table Name">
            <template slot-scope="scope">
              {{ scope.row.sSchema }}.{{ scope.row.sTableName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="sStatus"
            label="Status"
            align="center"
            :formatter="formatterStatus"
          ></el-table-column>
          <el-table-column
            prop="sTableName"
            align="center"
            label="Check Result"
          >
            <template slot-scope="scope">
              <el-button @click="toDetail(scope.row)">Detail</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div style="float: right; margin-top: 20px">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="Result" :visible.sync="dialogFlag" width="50%">
      <el-table
        ref="multipleTable"
        :data="tableListData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="sFieldName" label="Field Name"></el-table-column>
        <el-table-column prop="sFieldType" label="Field Type"></el-table-column>
        <el-table-column prop="sResult" label="Result">
          <template slot-scope="scope">
            {{ scope.row.sResult == 1 ? "不通过" : "通过" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import { selectTemplateLogPage, getUploadResultDetail } from "../../api/api";
export default {
  data() {
    return {
      activeName: "first",
      filters: {
        pageSize: 10,
        currentPage: 1,
      },
      total: 0,
      dialogFlag: false,
      tableListData: [],
			tableData: [],
      headerStyle: {
        height: "50px",
        backgroundColor: "#000",
        color: "#fff",
        padding: "0px",
      },
      cellStyle: {
        height: "55px",
      },
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    toDetail(data) {
      getUploadResultDetail({
        nUploadId: data.nId,
      }).then((res) => {
        this.dialogFlag = true;
        this.tableListData = res.data;
      });
    },
    formatterStatus(row) {
      if (row.sStatus == 0) {
        return "Uploading";
      } else if (row.sStatus == 1) {
        return "Success";
      } else if (row.sStatus == 2) {
        return "Fail";
      } else if (row.sStatus == 3) {
        return "Value mismatch";
      } else if (row.sStatus == 4) {
        return "Primary key duplication";
      } else {
        return row.sStatus;
      }
    },
    handleCurrentChange(page) {
      this.filters.currentPage = page;
      this.getList();
    },
    reGetList: function () {
      this.filters.currentPage = 1;
      this.getList();
    },
    getList: function () {
      var param = Object.assign({}, this.filters);
      selectTemplateLogPage(param).then((res) => {
        this.tableData = res.data;
        this.total = res.page.totalCount * 1;
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// result.vue?f09e1e8a